// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__35rd8","label":"LabeledBox_label__2F0Rw"};